import {action} from 'typesafe-actions';
import {SnackBarActionTypes, ISnackBarState} from './snackbar.types';

export const showSnackBar = (payload: ISnackBarState) => action(SnackBarActionTypes.SHOW, {payload});
export const hideSnackBar = () => action(SnackBarActionTypes.HIDE);
